import React from "react";
import "./TableStyles.scss";
import locked from "../../../../assets/Lock.svg";
import res from "../../../../assets/booking.svg";

interface TableProps {
  height: number;
  width: number;
  chairCount: number;
  type: "RECTANGLE" | "CIRCLE";
  name: string;
  isLocked?: boolean;
  status?: any;
  isView: boolean;
  isEdit: boolean;
  reservationCount?: number;
  isNew?: boolean;
  min: number;
  max: number;
}

const Table: React.FC<TableProps> = ({
  height,
  width,
  chairCount,
  type,
  name,
  isLocked,
  status,
  isView,
  isEdit,
  reservationCount,
  isNew,
  min,
  max,
}) => {
  const getTablePos = () => {
    let topCount, bottomCount;

    if (chairCount % 2 === 0) {
      topCount = bottomCount = chairCount / 2;
    } else {
      topCount = Math.ceil(chairCount / 2);
      bottomCount = Math.floor(chairCount / 2);
    }

    return { topCount, bottomCount };
  };
  return (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
      className='Table'
    >
      {isNew && (
        <div className='covers-count'>
          Covers - {min},{max}
        </div>
      )}
      {isView && reservationCount && reservationCount > 0 ? (
        <div className='table-count'>
          <img alt='' src={res} />
          {reservationCount}
        </div>
      ) : (
        ""
      )}
      <div className='top'>
        {Array.from({ length: getTablePos().topCount }).map((_, index) => {
          return (
            <div className='chair-wrapper' key={index}>
              <div className='chair' />
            </div>
          );
        })}
      </div>
      <div className='center' style={{ height: `${height - 30}px` }}>
        <div className='chair-cont'>
          <div className='chair' />
        </div>
        <div
          className='table-cont'
          style={{ borderRadius: type === "CIRCLE" ? "50%" : "" }}
        >
          <div
            className='inner-cont'
            style={{
              backgroundColor: !isView
                ? isLocked
                  ? "#E8361E"
                  : ""
                : status
                ? `${status.Color}`
                : "",
              borderRadius: type === "CIRCLE" ? "50%" : "",
            }}
          >
            {!isView ? (
              isLocked ? (
                <img alt='' src={locked} className='img' />
              ) : (
                ""
              )
            ) : status ? (
              <img alt='' src={status.Icon} className='img-status' />
            ) : (
              ""
            )}
          </div>
        </div>
        <div className='chair-cont'>
          <div className='chair' />
        </div>
      </div>
      <div className='bottom'>
        {Array.from({ length: getTablePos().bottomCount }).map((_, index) => {
          return (
            <div className='chair-wrapper' key={index}>
              <div className='chair' />
            </div>
          );
        })}
      </div>
      <div className='table-name'>{name}</div>
    </div>
  );
};

export default Table;
